// import { sprintf } from '../../../third_party/sprintf-js';

import { language } from '../../localization';

class Publisher {
  static createFromData(data) {
    const publisher = new Publisher();
    publisher.data = data;
    publisher.postProcessed = false;

    return publisher;
  }

  static createFromApp(app, userData) {
    const publisher = new Publisher();

    // leave the hint for the PublisherBadge class
    publisher.lang = app.data.lang || language();

    let guideDesc = '';
    if (userData !== undefined) {
      try {
        const desc = JSON.parse(userData.desc);
        guideDesc = desc[publisher.lang]; // get the user default one if possible
      } catch (error) {
        console.log('userData.desc parse error');
        console.log(error);
      }
    }
    guideDesc = app.data.guideDesc || guideDesc;

    publisher.pp.desc = {};
    publisher.pp.desc[publisher.lang] = guideDesc;
    publisher.pp.langs = [publisher.lang];

    publisher.data.uuid = app.data.user || 'createFromApp-error-NoUuid';
    publisher.data.name = app.data.guideName || '';
    publisher.data.desc = JSON.stringify(publisher.pp.desc);
    publisher.data.langs = JSON.stringify(publisher.pp.langs);
    publisher.data.image = app.data.guideImage || '';
    publisher.data.rating = app.data.guideRating || 0;
    publisher.data.reviews = app.data.guideReviews || 0;

    if (userData !== undefined) {
      if (publisher.data.name === '') {
        publisher.data.name = userData.name || '';
      }
      if (publisher.data.image === '') {
        publisher.data.image = userData.image || '';
      }
      if (publisher.data.rating === 0) {
        publisher.data.rating = userData.rating || 0;
      }
      if (publisher.data.reviews === 0) {
        publisher.data.reviews = userData.reviews || 0;
      }
    }

    return publisher;
  }

  constructor() {
    this.data = {
      __typename: 'Users',
      uuid: '1',
      year: 2025,
      langs: '["en"]',
      // name: '',
      desc: '{"en": ""}',
      // image: '',
      username: 'unnamed',
      approve: 0,
      rating: 0,
      reviews: 0,
    };
    this.pp = {};

    this.postProcessed = false;
    this.lang = 'en';
  }

  clone() {
    return Publisher.createFromData(JSON.parse(JSON.stringify(this.data)));
  }

  makeOptimistic() {
    if (!this.data.uuid) {
      this.data.uuid = 'not-inserted-yet-%s' % Math.random().toString();
    }
    return this;
  }

  output() {
    // console.log('output');
    // console.log(this.data);
    return this.data;
  }

  postProcess() {
    if (this.postProcessed) {
      return;
    }

    this.pp = JSON.parse(JSON.stringify(this.data));
    this.pp.langs = JSON.parse(this.data.langs);
    this.pp.desc = this.data.desc ? JSON.parse(this.data.desc) : {};

    this.postProcessed = true;
  }
}

export default Publisher;
